// extracted by mini-css-extract-plugin
export default {"submit":"Quiz_submit__gP1Xy","score":"Quiz_score__kS51R"};